import './index.scss'
import { observer } from 'mobx-react-lite'
import XImg from '@assets/svg/x.svg'
import { Context } from '@/index'
import { useContext } from 'react'
import ShieldGreenImg from '@assets/svg/shield-green.svg';

const DepositSuccessModal = observer(({transactionId = ''}) => {
    const { modal } = useContext(Context);

    return (
        <div className="deposit-success-modal">
            <div className="header-modal">
Əməliyyatın statusu
                <div className="x-block" onClick={() => modal.closeModal()}>
                    <img src={XImg} className="x" alt="close"/>
                </div>
            </div>
            <form className="form">
                <div className="status-icon">
                    <img src={ShieldGreenImg} alt="success" />
                </div>
                <h1 className="status-title">
Ödəniş tamamlandı
                </h1>
                <h5 className="status-subtitle">
Bank tranzaksiyanız <span className="transaction-id-bold">{transactionId && `№${transactionId}`}</span> uğurla tamamlandı.
                </h5>
                <div className="actions">
                    <button type='button' className="confirm" onClick={() => modal.closeModal()}>
Bağla
                    </button>
                </div>
            </form>
        </div>
    )
})

export { DepositSuccessModal }